import { ItiBaseDto } from '@/iti-core-vue';

export class FormattedCategory extends ItiBaseDto {
    //public id !: number;
    public nodeParentId !: string;
    public categoryId !: string;
    public level !: number;
    public code !: string;
    public description !: string;
    public expanded = false;
}